<h2 mat-dialog-title class="flex justify-between items-center">
    Change Password
</h2>
<hr>

<mat-dialog-content>
    <form [formGroup]="form" class="flex flex-col gap-4">
        <div class="flex flex-wrap w-full sm:w-full input-control">
            <label for="currentPassword" class="text-sm font-medium text-gray-700 mb-1 w-full sm:w-1/2">Old Password *</label>
            <div class="w-full sm:w-1/2 relative">
                <input [type]="hideOldPassword ? 'password' : 'text'" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" id="currentPassword" formControlName="currentPassword" [ngClass]="{ 'input-error': submitted && (form.get('currentPassword')?.hasError('required') || form.get('currentPassword')?.hasError('minlength')) }">
                <div class="flex">
                    <mat-icon class="password-visible-icon" [fontIcon]="hideOldPassword ? 'visibility' : 'visibility_off'" (click)="hideOldPassword = !hideOldPassword"></mat-icon>
                </div>
                <mat-error *ngIf="submitted && form.get('currentPassword')?.hasError('required')">Password is required</mat-error>
                <mat-error *ngIf="submitted && form.get('currentPassword')?.hasError('minlength')">Minimum 8 characters required</mat-error>
            </div>
        </div>
        <div class="flex flex-wrap w-full sm:w-full input-control">
            <label for="newPassword" class="text-sm font-medium text-gray-700 mb-1 w-full sm:w-1/2">New Password *</label>
            <div class="w-full sm:w-1/2 relative">
                <input [type]="hideNewPassword ? 'password' : 'text'" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" id="newPassword" formControlName="newPassword" [ngClass]="{ 'input-error': submitted && (form.get('newPassword')?.hasError('required') || form.get('newPassword')?.hasError('minlength')) }">
                <div class="flex">
                    <mat-icon class="password-visible-icon" [fontIcon]="hideNewPassword ? 'visibility' : 'visibility_off'" (click)="hideNewPassword = !hideNewPassword"></mat-icon>
                </div>
                <mat-error *ngIf="submitted && form.get('newPassword')?.hasError('required')">Password is required</mat-error>
                <mat-error *ngIf="submitted && form.get('newPassword')?.hasError('minlength')">Minimum 8 characters required</mat-error>
            </div>
        </div>
        <div class="flex flex-wrap w-full sm:w-full input-control">
            <label for="confirmPassword" class="text-sm font-medium text-gray-700 mb-1 w-full sm:w-1/2">Confirm Password *</label>
            <div class="w-full sm:w-1/2 relative">
                <input [type]="hideConfirmPassword ? 'password' : 'text'" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" id="confirmPassword" formControlName="confirmPassword" [ngClass]="{ 'input-error': form.get('confirmPassword')?.value && form.errors?.['mismatch'] }">
                <div class="flex">
                    <mat-icon class="password-visible-icon" [fontIcon]="hideConfirmPassword ? 'visibility' : 'visibility_off'" (click)="hideConfirmPassword = !hideConfirmPassword"></mat-icon>
                </div>
                <mat-error *ngIf="form.get('confirmPassword')?.value && form.errors?.['mismatch']">Passwords do not match</mat-error>
            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <label class="error-message">{{errorMessage}}</label>
    <button mat-raised-button color="primary" class="btn-primary" (click)="onSubmit()" [disabled]="form.invalid">Submit</button>
    <button mat-button (click)="onCancel()">Cancel</button>
</mat-dialog-actions>